import { formatProjection } from '../../../../shared/format-currency.js';

/**
 * Renders a balance projection with before → after and signed difference.
 * Example: Checking: $1,000.00 → $950.00 (-$50.00)
 * @param {Object} props
 * @param {string} props.name
 * @param {number} props.before
 * @param {number} props.after
 * @param {number} props.dps
 * @param {string} props.symbol
 * @returns {JSX.Element}
 */
export function BalanceProjection({ name, before, after, dps, symbol }) {
	return <span>{formatProjection(name, before, after, { decimalPlaces: dps, symbol })}</span>;
}
